module.exports = __webpack_public_path__ + "img/T944.05c95c37.jpg";